import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar
} from 'reactstrap';  
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addMeioAmbienteDivisao, updateMeioAmbienteDivisao } from "../../Services/MeioAmbienteDivisaoService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: '',
				name: '',
        code: '',
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }
      
      if(data.id === undefined || data.id === null || data.id === ''){
        addMeioAmbienteDivisao(data)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear({});              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateMeioAmbienteDivisao(data)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldCode'));
      validated = false;
    }

    return validated;
  }

  loadData(selected) {
    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {

        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected } = this.props;
    this.loadData(selected);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected){
      this.loadData(this.props.selected);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['code'] = '';
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_MEIO_AMBIENTE_DIVISAO_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.code')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="code"
                      value={this.state.data.code}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'meioAmbienteDivisaoEdit', 
})(withTranslation('common')(CrudEdit));
